import { render, staticRenderFns } from "./customerServiceStatistics.vue?vue&type=template&id=51a6b0e2&scoped=true&"
import script from "./customerServiceStatistics.vue?vue&type=script&lang=js&"
export * from "./customerServiceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceStatistics.vue?vue&type=style&index=0&id=51a6b0e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6b0e2",
  null
  
)

component.options.__file = "customerServiceStatistics.vue"
export default component.exports